import axios from 'axios'
import type { app, appfilter, updateshowapp, updatenoteapp, apkUpload } from '../types/types'

const baseurl = `${import.meta.env.VITE_APP_PROTOCOL}://${import.meta.env.VITE_API_HOST}:${import.meta.env.VITE_API_PORT}/${import.meta.env.VITE_API_SUBPATH}`
const url = 'app'

export const readAppListAPI = async (appfilter: appfilter): Promise<app[]> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'list',
      ...appfilter
    }
  })
  console.log("readAppListAPI 응답:", response.data)
  return response.data.data
}

export const updateShowAppAPI = async (updateshowapp: updateshowapp): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'update',
      ...updateshowapp
    }
  })
  console.log("updateShowAppAPI 응답:", response.data)
  return response.data.data
}

export const updateNoteAppAPI = async (updatenoteapp: updatenoteapp): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'update',
      ...updatenoteapp
    }
  })
  console.log("updateNoteAppAPI 응답:", response.data)
  return response.data
}

export const deleteAppAPI = async (id: number): Promise<boolean> => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'delete',
      id: id,
    }
  })
  console.log("deleteAppAPI 응답:", response.data)
  return response.data
}

export const apkUploadAPI = async (apkUpload: apkUpload) => {
  const formData = new FormData();

  formData.append('cmd', 'add');
  formData.append('apkfile', apkUpload.apkfile);
  if (apkUpload.relnote) {
    formData.append('relnote', apkUpload.relnote);
  }
  const response = await axios.post(`${baseurl}app`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  console.log("apkUploadAPI 응답:", response)
  return response.data;
}

export const paginationAppAPI = async (appfilter: appfilter) => {
  const response = await axios.get(`${baseurl}${url}`, {
    params: {
      cmd: 'pagination',
      ...appfilter
    }
  })
  console.log("paginationAppAPI 응답:", response.data)
  return response.data.data.totalpage
}


